/**
 *@author shaolei
 *@date 2020/04/07
 *@file_name:form
 *@Description:
 */
<template>
  <div class="form">
    <el-form ref="applyForm" label-position="top" :model="params" :rules="rules">
      <el-form-item label="应用名称" prop="title" class="item">
        <el-input maxlength="15" show-word-limit v-model="params.title" placeholder="不超过15个字符"></el-input>
      </el-form-item>
      <el-form-item label="应用类型" prop="type" class="item">
        <el-select v-model="params.type" placeholder="请选择应用类型">
          <el-option label="类型1" value="shanghai"></el-option>
          <el-option label="类型2" value="beijing"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="应用描述" maxlength="100" prop="desc" class="item">
        <el-input
          maxlength="100"
          show-word-limit
          type="textarea"
          v-model="params.desc"
          placeholder="请输入应用描述"
        ></el-input>
      </el-form-item>
      <div @click="next" class="btn">下一步</div>
    </el-form>
  </div>
</template>

<script>
import { editAudit } from "@/validate/rules.js";
export default {
  name: "vform",
  data() {
    return {
      params: {
        title: "",
        desc: "",
        type: ""
      },
      rules: editAudit
    };
  },

  components: {
    //组件声明
  },

  computed: {
    //计算属性
  },

  created() {
    //创建时执行
  },

  mounted() {
    //数据挂载
  },

  methods: {
    //函数声明
    next() {
      let that = this;
      this.$refs.applyForm.validate(valid => {
        if (valid) {
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang='less' scoped>
.form {
  width: 440px;
  margin: 0 auto;
  padding-top: 40px;

  .item {
    .label {
      font-size: 14px;

      span {
        color: #f16555;
        padding-left: 5px;
        vertical-align: middle;
      }
    }
  }

  /deep/ .el-textarea {
    /deep/ .el-textarea__inner {
      min-height: 160px !important;
    }
  }

  /deep/.el-select {
    width: 100%;
  }

  .btn {
    height: 46px;
    line-height: 46px;
    text-align: center;
    background: #fabe00;
    border-radius: 2px;
    color: #333;
    -moz-user-select: none; /*火狐*/
    -webkit-user-select: none; /*webkit浏览器*/
    -ms-user-select: none; /*IE10*/
    -khtml-user-select: none; /*早期浏览器*/
    user-select: none;
    cursor: pointer;
    margin-top: 30px;
  }
}
</style>